module.exports = __webpack_public_path__ + "img/tingchechang2.b0df301e.jpg";